/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Componente_PD_80_68 as Componente_PD_80_68,
  rec_JSXRuntime as JSXRuntime,
  rec_ND as ND,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_XE as XE,
  rec_Yx as Yx,
  rec_bD as bD,
  rec_gD as gD,
} from "../../runtime/index.jsx";
export function Componente_MD_77_68(e) {
  let t = (0, ReactCompiler.c)(27),
    { id: n, tareas: r, onCard: i, soloLectura: a } = e,
    o;
  t[0] === n
    ? (o = t[1])
    : ((o = {
        id: n,
      }),
      (t[0] = n),
      (t[1] = o));
  let { setNodeRef: s, isOver: c } = XE(o),
    l = `flex min-h-32 flex-col gap-2 rounded-2xl p-2 transition ${c ? `bg-(--accent-bg)` : `bg-(--panel)`}`,
    u;
  t[2] === n ? (u = t[3]) : ((u = Yx(n)), (t[2] = n), (t[3] = u));
  let d;
  t[4] !== u || t[5] !== r.length
    ? ((d = (
        <p
          className={`px-1 text-xs font-semibold uppercase tracking-wide text-(--text)`}
          children={[u, ` · `, r.length]}
        />
      )),
      (t[4] = u),
      (t[5] = r.length),
      (t[6] = d))
    : (d = t[6]);
  let f;
  t[7] === r ? (f = t[8]) : ((f = r.map(ND)), (t[7] = r), (t[8] = f));
  let p;
  if (t[9] !== i || t[10] !== a || t[11] !== r) {
    let e;
    (t[13] !== i || t[14] !== a
      ? ((e = (e) => (
          <Componente_PD_80_68
            key={e.id}
            t={e}
            onClick={() => i(e)}
            soloLectura={a}
          />
        )),
        (t[13] = i),
        (t[14] = a),
        (t[15] = e))
      : (e = t[15]),
      (p = r.map(e)),
      (t[9] = i),
      (t[10] = a),
      (t[11] = r),
      (t[12] = p));
  } else p = t[12];
  let m;
  t[16] !== f || t[17] !== p
    ? ((m = (0, JSXRuntime.jsx)(bD, {
        items: f,
        strategy: gD,
        children: p,
      })),
      (t[16] = f),
      (t[17] = p),
      (t[18] = m))
    : (m = t[18]);
  let h;
  t[19] === r.length
    ? (h = t[20])
    : ((h = r.length === 0 && (
        <span className={`px-1 text-[11px] text-(--text)`} children={`—`} />
      )),
      (t[19] = r.length),
      (t[20] = h));
  let _;
  return (
    t[21] !== s || t[22] !== l || t[23] !== d || t[24] !== m || t[25] !== h
      ? ((_ = <div ref={s} className={l} children={[d, m, h]} />),
        (t[21] = s),
        (t[22] = l),
        (t[23] = d),
        (t[24] = m),
        (t[25] = h),
        (t[26] = _))
      : (_ = t[26]),
    _
  );
}
